import * as React from "react";


export function useFormState(defaults) {
    const [state, setState] = React.useState({ ...defaults });

    return {
        getValues() {
            return state;
        },

        setValues(values) {
            setState(state => ({ ...state, ...values }));
        },

        getTextFieldProps(name) {
            return {
                name,
                value: state[name] || "",
                onChange(event) {
                    const { value } = event.target;
                    setState(state => ({
                        ...state,
                        [name]: value,
                    }));
                },
            }
        },
    };
}
